module.exports = __webpack_public_path__ + "img/play-button.94bded41.png";